import type { AdminPageAccessRule } from '../../registry.ts';

/** Хто бачить сторінку `company`: у перший екран їде лише це (опис і код — у `page.ts`). */
export default {
  group: 'company',
  permission: 'settings.manage',
} satisfies AdminPageAccessRule;
